import { TRIGGER_FETCH_AGENTS } from '../../../actions/travelUg/agentModal';
import { getAgentsService } from './agents';
import { COLLECT_LOGIN_DETAILS } from '../../../actions/travelUg/auth';
import { loginService } from './login';
import {
    TRIGGER_AML_WHITELIST_CHECK,
    TRIGGER_TRAVEL_DETAILS_ID_DOCUMENT_ID_SAVE,
    TRIGGER_TRAVEL_DETAILS_PASSPORT_DOCUMENT_ID_SAVE,
    TRIGGER_TRAVEL_DETAILS_DOCUMENT_UPLOAD_CHECKS,
    SUBMIT_TRAVEL_DETAILS_FORM_DATA,
} from '../../../actions/travelUg/travelDetails';
import { amlWhitelistCheckService } from './amlWhitelist';
import { idUploadService } from './idFileUpload';
import { passportUploadService } from './passportFileUpload';
import { documentUploadChecksService } from './documentUploadChecks';
import {
    COLLECT_TRAVEL_UG_INSURANCE_QUOTE_FORM_DATA,
    COLLECT_SHARE_QUOTE_FORM_DATA,
    SUBMIT_TRAVEL_UG_QUOTE_FORM_DATA,
    UPDATE_TRAVEL_UG_QUOTE_FORM_DATA,
} from '../../../actions/travelUg/quote';
import { premiumCalculationService } from './premiumCalculation';
import { shareQuoteService } from './shareQuote';
import { TRIGGER_GET_COUNTRIES, TRIGGER_GET_USD_RATE } from '../../../actions/travelUg/quote';
import { getCountriesService } from './countries';
import { getUsdRateService } from './usdRate';
import {
    TRIGGER_PAYMENTS_STK_PUSH,
    CHECK_PAYMENTS_STATUS,
    SUBMIT_PAYMENT_FORM_DATA,
    //TRIGGER_CONFIRM_ORDER,
} from '../../../actions/travelUg/payments';
import { paymentsStkService, paymentsStkStatusService } from './payments';
import { COLLECT_PAYLOAD_DATA } from '../../../actions/travelUg/payloadCollection';
import { payloadSubmitService } from './payloadCollection';
import { submitQuoteService } from './submitQuote';
import { submitTravelDetailsService } from './submitTravelDetails';
import { SUBMIT_NEXT_OF_KIN_FORM_DATA } from '../../../actions/travelUg/nextOfKin';
import { submitNextOfKinService } from './submitNextOfKin';
import { submitPaymentDataService } from './submitPaymentData';
import { updateQuoteService } from './updateQuote';

export const travelUgCover = (store, next, action) => {
    if (action.type.startsWith(TRIGGER_AML_WHITELIST_CHECK)) {
        return amlWhitelistCheckService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_LOGIN_DETAILS)) {
        return loginService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_FETCH_AGENTS)) {
        return getAgentsService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_TRAVEL_UG_INSURANCE_QUOTE_FORM_DATA)) {
        return premiumCalculationService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_COUNTRIES)) {
        return getCountriesService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_USD_RATE)) {
        return getUsdRateService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_SHARE_QUOTE_FORM_DATA)) {
        return shareQuoteService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_PAYMENTS_STK_PUSH)) {
        return paymentsStkService(store, next, action);
    }
    if (action.type.startsWith(CHECK_PAYMENTS_STATUS)) {
        return paymentsStkStatusService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_PAYLOAD_DATA)) {
        return payloadSubmitService(store, next, action);
    }

    /*
     if (action.type.startsWith(TRIGGER_CONFIRM_ORDER)) {
        return orderConfirmationService(store, next, action);
    }
    */

    if (action.type.startsWith(TRIGGER_TRAVEL_DETAILS_ID_DOCUMENT_ID_SAVE)) {
        return idUploadService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_TRAVEL_DETAILS_PASSPORT_DOCUMENT_ID_SAVE)) {
        return passportUploadService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_TRAVEL_DETAILS_DOCUMENT_UPLOAD_CHECKS)) {
        return documentUploadChecksService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_TRAVEL_UG_QUOTE_FORM_DATA)) {
        return submitQuoteService(store, next, action);
    }

    if (action.type.startsWith(UPDATE_TRAVEL_UG_QUOTE_FORM_DATA)) {
        return updateQuoteService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_TRAVEL_DETAILS_FORM_DATA)) {
        return submitTravelDetailsService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_NEXT_OF_KIN_FORM_DATA)) {
        return submitNextOfKinService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_PAYMENT_FORM_DATA)) {
        return submitPaymentDataService(store, next, action);
    }

    return null;
};
